import * as React from 'react';
import { Layout, Row, Col, Card } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { buyerSettingsRestCrudThunksForBuyer } from '../../thunks/buyer_settings_thunks';
import {
	BUYER_NOTIFICATION_RFP_STATUS_DISPLAY_NAMES,
	BUYER_NOTIFICATION_WORK_ORDER_STATUS_DISPLAY_NAMES,
	WORK_ORDER_STATUS_DISPLAY_NAMES,
} from '../../constants/WorkOrderStatuses';
import EditableCellTable from '../editable_cell_table/EditableCellTable';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';

const { Content } = Layout;

require('./BuyerNotificationsSettingsPage.less');

class BuyerNotificationsSettingsPage extends React.Component<any, any> {
	componentDidMount() {
		const { getBuyerSettings, currentUser } = this.props;
		getBuyerSettings(encodeURIComponent(currentUser.email));
	}

	updateWorkOrderNotificationsSettings = (newSetting) => {
		const { buyerSettings, updateBuyerSettings } = this.props;
		const newBuyerSettings = {
			...buyerSettings,
			workOrderNotifications: {
				...buyerSettings.workOrderNotifications,
				[newSetting.key]: {
					sms: typeof newSetting.sms === 'undefined' ? false : newSetting.sms,
					email: newSetting.email,
					inApp: newSetting.inApp,
				},
			},
		};
		updateBuyerSettings(newBuyerSettings);
	};

	updateRFPNotificationsSettings = (newSetting) => {
		const { buyerSettings, updateBuyerSettings } = this.props;
		const newBuyerSettings = {
			...buyerSettings,
			rfpNotifications: {
				...buyerSettings.rfpNotifications,
				[newSetting.key]: {
					sms: typeof newSetting.sms === 'undefined' ? false : newSetting.sms,
					email: newSetting.email,
					inApp: newSetting.inApp,
				},
			},
		};
		updateBuyerSettings(newBuyerSettings);
	};

	render() {
		const { buyerSettingsFetching, buyerSettings } = this.props;
		const getNotificationsArray = (notifications, displayNamesMap) =>
			Object.keys(notifications).map((k) => {
				return { ...notifications[k], key: k, displayName: displayNamesMap[k] };
			});
		let defaultWorkOrderNotifications = {};
		Object.keys(BUYER_NOTIFICATION_WORK_ORDER_STATUS_DISPLAY_NAMES).map((key) => {
			defaultWorkOrderNotifications[key] = { email: true, inApp: true };
		});
		const workOrderNotifications = {
			...defaultWorkOrderNotifications,
			...buyerSettings.workOrderNotifications,
		};
		const workOrderNotificationsArray = getNotificationsArray(
			workOrderNotifications,
			BUYER_NOTIFICATION_WORK_ORDER_STATUS_DISPLAY_NAMES
		);

		let defaultRFPNotifications = {};
		Object.keys(BUYER_NOTIFICATION_RFP_STATUS_DISPLAY_NAMES).map((key) => {
			defaultRFPNotifications[key] = { email: true, inApp: true };
		});
		const rfpNotifications = { ...defaultRFPNotifications, ...buyerSettings.rfpNotifications };
		const rfpNotificationsArray = getNotificationsArray(
			rfpNotifications,
			BUYER_NOTIFICATION_RFP_STATUS_DISPLAY_NAMES
		);

		const workOrderNotificationsColumns = [
			{
				title: 'Work Order Notifications',
				dataIndex: 'displayName',
				width: '640px',
				render: (text) => <span style={{ fontSize: 16 }}>{text}</span>,
			},
			{
				title: 'Email',
				dataIndex: 'email',
				width: '80px',
				editable: true,
				defaultValue: true,
			},
			{
				title: 'In App',
				dataIndex: 'inApp',
				width: '80px',
				editable: true,
				defaultValue: true,
			},
			// {
			//     title: 'SMS',
			//     dataIndex: 'sms',
			//     editable: true
			// },
		];
		const rfpNotificationsColumns = [
			{
				title: 'Request for Proposal Notifications',
				dataIndex: 'displayName',
				width: '640px',
				render: (text) => <span style={{ fontSize: 16 }}>{text}</span>,
			},
			{
				title: 'Email',
				dataIndex: 'email',
				width: '80px',
				editable: true,
				defaultValue: true,
			},
			{
				title: 'In App',
				dataIndex: 'inApp',
				width: '80px',
				editable: true,
				defaultValue: true,
			},
			// {
			//     title: 'SMS',
			//     dataIndex: 'sms',
			//     editable: true
			// },
		];

		return buyerSettingsFetching ? (
			<PageLoadingPlaceholder />
		) : (
			<Content className="buyerNotificationsSettingsPage">
				<LogOnMountWithStandardEventProperties eventType="visited buyer notifications settings page" />
				<Row className="rowSpacing">
					<Col style={{ maxWidth: 960, margin: 'auto' }} span={24}>
						<Card>
							<EditableCellTable
								showHeader={true}
								handleSave={this.updateWorkOrderNotificationsSettings}
								columns={workOrderNotificationsColumns}
								data={workOrderNotificationsArray}
							/>
						</Card>
					</Col>
				</Row>
				<Row className="rowSpacing">
					<Col style={{ maxWidth: 960, margin: 'auto' }} span={24}>
						<Card>
							<EditableCellTable
								showHeader={true}
								handleSave={this.updateRFPNotificationsSettings}
								columns={rfpNotificationsColumns}
								data={rfpNotificationsArray}
							/>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	currentUser: state.session.currentUser,

	buyerSettings: state.buyer_settings.detail,
	buyerSettingsFetching: state.buyer_settings.fetching,
});

const mapDispatchToProps = (dispatch) => ({
	getBuyerSettings: (email) => dispatch(buyerSettingsRestCrudThunksForBuyer.readOne(email)),
	updateBuyerSettings: (settings) => dispatch(buyerSettingsRestCrudThunksForBuyer.update(settings)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(BuyerNotificationsSettingsPage)
);
